export default __webpack_public_path__ + "static/media/Settings.a1fbeb07.svg";